import {serializeReviewAnalysisDate} from '../../../page/main/reviews-analysis/reviews-analysis-helper';
import {fetchAndDeserialize, serialize, serializeToURLParameters} from '../../../util/api-adapter';
import {FetchMethodEnum, fetchNoContent} from '../../../util/fetch';
import {objectToUrlParameters} from '../../../util/url';
import {getCsrfHeaders, mainApiHeaders, rootApiUrl} from '../../api/api-const';

import {
    ExportExcelType,
    FetchReviewConcordanceResultType,
    ReviewConcordanceRequestType,
    reviewConcordanceResponseSchema,
    ReviewConcordanceSentimentRequestType,
    reviewConcordanceSentimentResponseSchema,
    ReviewConcordanceSentimentType,
} from './review-concordance-type';

export async function fetchReviewConcordance(
    options: ReviewConcordanceRequestType,
    mainFilterKey: string
): Promise<FetchReviewConcordanceResultType> {
    const searchParameters = objectToUrlParameters({
        ...serializeToURLParameters({
            ...options,
            ...(options.startDate
                ? {
                      startDate: serializeReviewAnalysisDate(options.startDate),
                  }
                : {}),
            ...(options.endDate
                ? {
                      endDate: serializeReviewAnalysisDate(options.endDate),
                  }
                : {}),
        }),
        filter_key: mainFilterKey,
    });

    const url = `/v2/reviews-analytics/stats/concordance/?${searchParameters}`;

    return fetchAndDeserialize<FetchReviewConcordanceResultType>(url, reviewConcordanceResponseSchema);
}

export async function fetchReviewConcordanceSentiment(
    options: ReviewConcordanceSentimentRequestType,
    mainFilterKey: string
): Promise<ReviewConcordanceSentimentType> {
    const searchParameters = objectToUrlParameters({
        ...serializeToURLParameters({
            ...options,
            ...(options.startDate
                ? {
                      startDate: serializeReviewAnalysisDate(options.startDate),
                  }
                : {}),
            ...(options.endDate
                ? {
                      endDate: serializeReviewAnalysisDate(options.endDate),
                  }
                : {}),
        }),
        filter_key: mainFilterKey,
    });

    const url = `/v2/reviews-analytics/stats/concordance_sentiment/?${searchParameters}`;

    return fetchAndDeserialize<ReviewConcordanceSentimentType>(url, reviewConcordanceSentimentResponseSchema);
}

export async function fetchExportConcordance(options: ExportExcelType): Promise<void> {
    const url = `${rootApiUrl}/cp/reviews_analytics/download_concordance/`;

    return fetchNoContent(url, {
        method: FetchMethodEnum.post,
        headers: {...mainApiHeaders, ...getCsrfHeaders()},
        body: JSON.stringify(
            serialize({
                ...options,
                ...(options.startDate
                    ? {
                          startDate: serializeReviewAnalysisDate(options.startDate),
                      }
                    : {}),
                ...(options.endDate
                    ? {
                          endDate: serializeReviewAnalysisDate(options.endDate),
                      }
                    : {}),
            })
        ),
    });
}
